<template>
  <div class="allco">
    <div class="text_title">
      <p class="title">发展历程</p>
      <div class="word">
        函驿通电子保函服务平台是由河北筑正科技有限公司发起的互联网科技电子保函服务平台。作为开发运营的独立第三方，函驿通平台致力于打造全国性电子保函服务平台，提供给终端投标企业在线申请保函、在线担保确认、在线银行出函、在线查验保函等服务，帮助投标企业解决纸质保函流程复杂、真伪难辨的问题；帮助企业融通经营资金、提升资金使用效率，与交易平台对接，项目信息更准确；与银行系统直连，银行保函更放心。函驿通平台将积极配合行业监管部门的检查管理并积极践行国家在招采领域的互联网+的战略发展规划。
      </div>
      <div class="btn">
        <el-button size="medium" plain @click="goAboutPage">查看详情</el-button>
      </div>
    </div>
    <div class="picture">
      <div class="SwiperBox" ref="SwiperBox" @mouseenter="MouseFun('移入')" @mouseleave="MouseFun('移出')">
        <!-- 图片 -->
        <div class="imgBox" :style="{ left: `-${leftVal}px`, transition: `${ition}s` }" @click="goAbout()">
          <img style="margin-right: 30px" v-lazy="item.imgUrl" v-for="(item, index) in imgList" :key="index" />
          <!-- 复制第一张放到最后,以实现无缝无线循环滚动效果 -->
          <img style="margin-right: 30px" v-lazy="imgList[0].imgUrl" alt="" />
          <img style="margin-right: 30px" v-lazy="imgList[1].imgUrl" alt="" />
        </div>
        <!-- 左箭头按钮 -->
        <!-- 下方指示点容器 -->
        <!-- <div class="instBox">
          <div
            @click="instFun(index)"
            v-for="(item, index) in imgList.length"
            :key="index"
            :class="['inst', index == imgShow ? 'instActv' : '']"
          ></div>
        </div> -->
      </div>
      <div class="info">
        <a v-for="(item, index) in info" :key="index" :title="item.listdata" class="item" effect="dark">
          <div v-show="item.isIndex === word">
            <h3 class="time">{{ item.time }}</h3>
            <span class="text">{{ item.listdata }}</span>
          </div>
        </a>
      </div>
      <div class="thro">
        <p class="iconfont icon-arrow-left" @click="throttle(PrevFun)"></p>
        <!-- <div class="leftBtn" @click="throttle(PrevFun)">&larr;</div> -->
        <p class="number">
          <span>{{ imgShow + 1 }}</span>/{{ imgList.length }}
        </p>
        <!-- 右箭头按钮 -->
        <!-- <div class="rightBtn" @click="throttle(NextFun)">&rarr;</div> -->
        <p class="iconfont icon-arrow-right" @click="throttle(NextFun)"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          imgUrl: require("@/assets/home/banner1.jpg"),
        },
        {
          imgUrl: require("@/assets/home/banner2.jpg"),
        },
        {
          imgUrl: require("@/assets/home/banner3.jpg"),
        },
        {
          imgUrl: require("@/assets/home/banner4.jpg"),
        },
        {
          imgUrl: require("@/assets/home/banner5.jpg"),
        },
        {
          imgUrl: require("@/assets/home/banner6.jpg"),
        },
        {
          imgUrl: require("@/assets/home/banner7.jpg"),
        },
        {
          imgUrl: require("@/assets/home/banner8.jpg"),
        },
        {
          imgUrl: require("@/assets/home/banner9.jpg"),
        },
        {
          imgUrl: require("@/assets/home/banner10.jpg"),
        },
        {
          imgUrl: require("@/assets/home/banner11.jpg"),
        },
      ],
      leftVal: 0, // 轮播图盒子的偏移值
      flag: true, // 用来节流防止重复点击
      start: null, // 自动执行下一张定的时器
      imgWidth: 657, // 在这里填写你需要的图片宽度
      ition: 0.8, // 设置轮播图过度时间
      imgShow: 0, // 表示当前显示的图片索引
      word: 0,
      info: [
        {
          isIndex: 1,
          time: "2019年3月",
          listdata:
            "河北筑正科技有限公司成立，并推出函驿通电子保函平台，实现全流程线上保函申请",
        },
        {
          isIndex: 2,
          time: "2019年9月",
          listdata:
            "第一家担保公司入驻“函驿通”平台体系，自主研发的电子保函 “担保业务管理系统”正式启用，将传统的线下业务受理模式转化为 全流程电子化处理，提高出函效率的同时实现了电子保函数据的安全加密",
        },
        {
          isIndex: 3,
          time: "2020年3月",
          listdata:
            "“函驿通”电子保函服务平台实现了河北省内所有工程类招投标 项目的电子保函线上申请及出函",
        },
        {
          isIndex: 4,
          time: "2021年3月",
          listdata:
            "疫情期间，平台共处理保函500余份，确保投标企业疫情期间的保函需求",
        },
        {
          isIndex: 5,
          time: "2021年5月",
          listdata:
            "与中信银行签署了合作协议，并完成国内银行电子投标保函的办理和开具，所开具的银行电子保函使用电子印章并支持数字验签；",
        },
        {
          isIndex: 6,
          time: "2021年10月",
          listdata:
            "完成河北、山西、安徽、四川、新疆等多个地区公共资源交易中心对接，正式开启全国业务战略",
        },
        {
          isIndex: 7,
          time: "2021年11月",
          listdata:
            "“函驿通”电子保函服务平台与保险经纪公司达成合作，正式上 线“乾保网”保险保函服务平台，实现了在线开具保险公司投标保函；",
        },
        {
          isIndex: 8,
          time: "2021年11月",
          listdata:
            "与河北银行电子保函业务系统完成对接，实现了 河北银行电子保函在线开具，办理时间由原来的 3  个工作日缩短为 2 个小时；",
        },
        {
          isIndex: 9,
          time: "2022年5月",
          listdata:
            "完成内蒙古、广东等多个地区政采平台、公共资源交易平台的对接，进一步加强全国业务的扩展",
        },
        {
          isIndex: 10,
          time: "2022年7月",
          listdata:
            "与河北信投、廊坊国兴达成合作，进一步推进保函业务的办理和扩大",
        },
        {
          isIndex: 11,
          time: "2023年",
          listdata: "我们在前进",
        },
      ],
    };
  },
  watch: {
    imgShow: {
      handler: function (v, o) {
        if (v + 1) {
          this.word = v + 1;
        }
      },
      immediate: true,
    },
  },
  created() { },
  mounted() {
    this.getList();
  },
  methods: {
    goAboutPage() {
      this.$router.push('/about')
    },
    // 点击图片跳转到关于我们
    goAbout() {
      // this.$router.push('/about')
    },
    // 这里定义一个鼠标移入移出事件，鼠标悬停时停止自动轮播，鼠标移出则重新执行自动轮播
    MouseFun(type) {
      // 停止定时器            // 重新执行定时器
      type == "移入" ? clearTimeout(this.start) : this.getList();
    },
    // 此为自动轮播定时器
    getList() {
      this.start = setInterval(() => {
        this.NextFun();
      }, 15000);
    },
    // 这里通过额外封装的节流函数触发 PrevFun() 和 NextFun(),以达到防止重复点击的效果
    throttle(fun) {
      if (this.flag) {
        this.flag = false;
        fun(); // 此为模板中传递进来的PrevFun()或NextFun()函数
        setTimeout(() => {
          this.flag = true;
        }, 1200); // 节流间隔时间
      }
    },
    // 上一张
    PrevFun() {
      if (this.leftVal == 0) {
        // 判断显示的图片 是 第一张时执行
        // this.imgList.length是指循环图片数组的图片个数
        this.ition = 0; // 将过渡时间变成0，瞬间位移到最后一张图
        this.imgShow = this.imgList.length - 1; // 将高亮小点改为最后一张图
        this.leftVal = this.imgList.length * this.imgWidth; // 瞬间移动
        setTimeout(() => {
          // 通过延时障眼法,归原过渡时间,执行真正的“上一张”函数
          this.ition = 0.8;
          this.leftVal -= this.imgWidth;
        }, this.ition * 1000);
      } else {
        // 判断显示的图片 不是 第一张时执行
        this.ition = 0.8;
        this.leftVal -= this.imgWidth;
        this.imgShow--;
      }
    },
    // 下一张
    NextFun() {
      if (this.leftVal == (this.imgList.length - 1) * this.imgWidth) {
        // 判断显示的图片 是 最后一张时执行
        this.ition = 0.8;
        this.leftVal += this.imgWidth;
        this.imgShow = 0;
        setTimeout(() => {
          this.ition = 0;
          this.leftVal = 0;
        }, this.ition * 1000);
      } else {
        // 判断显示的图片 不是 最后一张时执行
        this.ition = 0.8;
        this.leftVal += this.imgWidth;
        this.imgShow++;
      }
    },
    // 点击小圆点
    instFun(index) {
      this.ition = 0.8;
      this.leftVal = index * this.imgWidth;
      this.imgShow = index;
    },
  },
};
</script>

<style lang='less' scoped>
.allco {
  display: flex;
  padding: 93px 0 73px 15%;
  height: 608px;
  // font-weight: bold;
  align-items: center;
  background-image: url("../../../assets/home/histry.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;

  .text_title {
    width: 40%;
    height: 100%;
    margin-right: 15px;

    .title {
      font-size: 24px;
      border-left: 5px solid #ffcb4e;
      padding-left: 10px;
      font-weight: bold;
    }

    .word {
      margin-top: 20px;
      line-height: 2;
      letter-spacing: 2px;
      font-size: 16px;
    }
  }

  .picture {
    width: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 60px;
    position: relative;
  }
}

.SwiperBox {
  position: relative;
  width: 100%;
  height: 347px;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
}

.imgBox {
  position: absolute;
  top: 0px;
  left: 0px;
  min-width: 500px;
  // height: 300px;
  display: flex;
  justify-content: flex-start;
}

/* 图片默认样式 */
.imgBox img {
  flex-shrink: 0;
  width: 627px;
  height: 347px;
  box-shadow: 0px 9px 21px 0px rgba(142, 142, 142, 0.41);
  border-radius: 3px;
}

/* 两个按钮共有的样式,也可直接使用箭头图片替代 */
.thro {
  display: flex;
  font-size: 30px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 15px;
}

.leftBtn,
.rightBtn {
  // position: absolute;
  // top: 50%;
  // transform: translateY(-50%);
  // width: 30px;
  // height: 30px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // background: rgba(109, 109, 109, 0.445);
  // color: #fff;
  // border-radius: 50%;
  // cursor: pointer;
  // font-size: 12px;
  // font-weight: 500;
}

.leftBtn {
  left: 10px;
}

.rightBtn {
  right: 10px;
}

/* 下方指示器盒子 */
.instBox {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 10px;
  display: flex;
}

/* 小圆点 */
.inst {
  width: 10px;
  height: 10px;
  border: 1px solid #ccc;
  margin-right: 8px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
}

.inst:last-child {
  margin-right: 0px;
}

.instActv {
  border: 1px solid #ff0000;
  background: #ff0000;
}

.btn {
  margin-top: 15px;
}

::v-deep .el-button.is-plain:focus,
.el-button.is-plain:hover {
  border: 2px solid #dcdfe6;
  color: #606266;
}

::v-deep .el-button {
  font-weight: bold;
  border: 2px solid #dcdfe6;
}

.number {
  margin: 0 20px;
  display: flex;
  align-items: end;

  span {
    font-size: 35px;
  }
}

.icon-arrow-right,
.icon-arrow-left {
  font-size: 30px;
}

.icon-arrow-left:hover {
  color: #1860f2;
}

.icon-arrow-right:hover {
  color: #1860f2;
}

::v-deep .iconfont {
  display: flex;
  align-items: center;
}

.info {
  position: absolute;
  top: 35%;
  left: 0;
  transform: translate(-30%, 0);
  width: 180px;
  max-height: 223.6px;
  min-height: 223.6px;
  // background-color: #0C48BC;
  box-shadow: 0px 1px 1px 0px rgba(206, 206, 206, 0.8);
  background: #1460F4;
  z-index: 999;
  padding: 20px;
  color: #fff;
  line-height: 1.4;
  letter-spacing: 2px;
  transition: all .3s;

  .time {
    margin-bottom: 10px;
    font-size: 22px;
  }

  .text {
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
  }
}
</style>